import { render, staticRenderFns } from "./Airticketorder.vue?vue&type=template&id=4145adc2&scoped=true"
import script from "./Airticketorder.vue?vue&type=script&lang=js"
export * from "./Airticketorder.vue?vue&type=script&lang=js"
import style0 from "./Airticketorder.vue?vue&type=style&index=0&id=4145adc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145adc2",
  null
  
)

export default component.exports